import utils from "@/utils/index";

export default {
  data() {
    return {
      // 主题主色与圆角，支持 URL 传参覆盖
      background: "#ffaa0a",
      borderRadius: "5px",
      // 支付方式样式（未选/选中）
      payMethodInactiveBorder: "rgba(204,204,204,1)",
      payMethodInactiveBg: "#fff",
      payMethodActiveBg: "#fff"
    };
  },
  mounted() {
    // 从 URL 获取主题参数
    const bg = utils.getUrlSearch("background");
    const radius = utils.getUrlSearch("borderRadius");
    if (bg) this.background = bg;
    if (radius) this.borderRadius = radius;
  },
  methods: {
    // 设置头部线条颜色
    setHeaderLineTheme() {
      return {
        borderBottom: `4px solid ${this.background} !important`
      };
    },
    // 设置头部check背景色
    setCheckTheme() {
      return {
        backgroundColor: this.background + " !important"
      };
    },
    // 设置倒计时颜色
    setCountdownTheme() {
      return {
        color: this.background + " !important"
      };
    },
    // 设置金额的样式
    setAmountTheme() {
      return {
        color: this.background + " !important"
      };
    },
    // 设置按钮主题色
    setBtnTheme() {
      return {
        backgroundColor: this.background + " !important",
        border: `1px solid ${this.background} !important`,
        borderRadius: this.borderRadius
      };
    },
    // 设置支付方式选项主题色（根据是否选中）
    setPayMethodTheme(isActive, isHovered = false) {
      const active = Boolean(isActive || isHovered);
      if (active) {
        return {
          border: `1px solid ${this.background} !important`,
          background: this.payMethodActiveBg
        };
      }
      return {
        border: `1px solid ${this.payMethodInactiveBorder} !important`,
        background: this.payMethodInactiveBg
      };
    },
    setH5PayMethodTheme(isActive) {
      if (isActive) {
        return {
          backgroundColor: this.background,
          borderColor: this.background,
          width: "16px",
          height: "16px",
          borderRadius: "50%"
        };
      }
      return {
        backgroundColor: "#fff",
        borderColor: this.payMethodInactiveBorder,
        width: "16px",
        height: "16px",
        borderRadius: "50%",
        borderWidth: "1px",
        borderStyle: "solid"
      };
    },
    // 获取确认按钮的颜色，使用主题色
    getConfirmButtonColor() {
      return this.background || "#FFAA0A";
    }
  }
};
